import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import configureStore from 'Store/configureStore';
import { checkLogin } from 'Actions/auth'
import App from './App'
import 'Scss/index.scss';

let store = configureStore();
store.dispatch(checkLogin());

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);
